import { createContext } from 'react';

// { connection: GameConnection, superAdmin: boolean } of the game that is currently shown
export default createContext({ connection: null, superAdmin: false });
